<template>
  <div class="vhp-dialog">
    <div class="dialog" :id="id">
      <div class="dialog-container">
        <div class="header">
          <h3 v-if="title">{{ title }}</h3>

          <button
            @click="preventClose ? $emit('close') : close()"
            class="close-btn"
            v-if="!hideClose"
          >
            <i class="fas fa-close"/>
          </button>
        </div>

        <div class="content" :style="!noGutters ? 'padding:0 18px; width:calc(100% - 36px);' :''">
          <slot name="content" />
        </div>

        <div class="action" v-if="$slots.action">
          <slot name="action"/>
        </div>
      </div>
    </div>

    <!-- dialog 배경 sheet -->
    <div v-if="overlay" class="dialog-sheet" :id="id" @click="close"></div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    id: {
      type: String,
      required: true,
    },
    preventClose: {
      type: Boolean,
      default: false,
    },
    hideClose: Boolean,
    overlay: {
      type: Boolean,
      default: true,
    },
    // STYLE
    width: {
      type: [String, Number],
      default: 550,
    },
    height: {
      type: [String, Number],
      default: 550,
    },
    noGutters: Boolean
  },
  data() {
    return {};
  },
  computed: {
    dialogStyle() {
      return {
        width: this.width + "px",
        height: this.height + "px",
      };
    },
  },
  methods: {
    load() {
      // document.querySelector("body").style.overflow = "hidden";
      document.querySelector(`#${this.id}`).style.display = "block";
      document.querySelector(`.dialog-sheet#${this.id}`).style.display =
        "block";

      this.$emit("load");
    },

    close() {
      // document.querySelector("body").style.overflow = "auto";
      document.querySelector(`#${this.id}`).style.display = "none";
      document.querySelector(`.dialog-sheet#${this.id}`).style.display = "none";
    },
  },
  mounted() {},
};
</script>

<style lang="scss" src="./vhpDialog.scss"></style>
